import type { ParsedPublicMessage } from '@module/types/centrifuge/messageTypes';
import { isMediaUpdateMessage, type MediaUpdateMessage } from '@module/types/centrifuge/public-message/etcMessageTypes';
import type { MessageHandler, MessageHandlerAction, MessageHandlerContext } from '../types';

export class MediaUpdateHandler implements MessageHandler {
  constructor(private customAction?: MessageHandlerAction<MediaUpdateMessage>) {}

  canHandle(payload: ParsedPublicMessage): boolean {
    return isMediaUpdateMessage(payload);
  }

  handle(payload: MediaUpdateMessage, context: MessageHandlerContext): void {
    if (this.customAction === null || this.customAction === undefined) return;

    if (typeof this.customAction === 'function') {
      this.customAction(payload, context);
      return;
    }

    // 기본 동작
    context.setLike?.(payload.data.message.likeCnt);
    context.setBookmark?.(payload.data.message.bookmarkCnt);
  }
}
